var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.60103 2.23695C1.70344 2.01622 1.92465 1.875 2.16798 1.875H18.8346C19.078 1.875 19.2992 2.01622 19.4016 2.23695C19.504 2.45768 19.469 2.71778 19.3119 2.90358L12.793 10.6122V17.5C12.793 17.7166 12.6808 17.9178 12.4966 18.0317C12.3123 18.1455 12.0822 18.1559 11.8885 18.059L8.55514 16.3923C8.3434 16.2865 8.20964 16.0701 8.20964 15.8333V10.6122L1.69075 2.90358C1.53362 2.71778 1.49862 2.45768 1.60103 2.23695ZM3.51504 3.125L9.31188 9.97975C9.40729 10.0926 9.45964 10.2356 9.45964 10.3833V15.4471L11.543 16.4887V10.3833C11.543 10.2356 11.5953 10.0926 11.6907 9.97975L17.4876 3.125H3.51504Z",
  fill: "#00538F"
});

function SvgFilter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/filter2.b9bef7b8.svg";
export { ForwardRef as ReactComponent };